<ng-container>
  <div class="loader absolute" *ngIf="isLoading">
    <svg class="circular" viewBox="25 25 50 50">
      <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"></circle>
    </svg>
  </div>
  <div class="filters-area" *ngIf="isHasViewPermission"> 
    <div class="filter">
      <div class="search-container" (click)="setSearchFocus()" [class.search-focus]="isFocusSearch" [class.disabled]="isLoading" style="height: 30px"><i class="material-icons" style="padding:6px 10px;">search</i>
        <input autocomplete="off" type="text" placeholder="Search..." [(ngModel)]="searchText" (input)="search()"/>
      </div>
      <div style="display: flex; gap: 8px;">
        <div class="btn-area">
          <div class="button button-white dense-icon-btn">
            <div class="btn-inner dense-icon-btn filter-btn">
              <div *ngIf="!selectedDealer" (click)="isShowDealerSelect = true">
                <comp-icon class="filter-icon" [icon]="'filter_list'" [size]="16" [color]="'hsla(0,0%,0%,0.6)'"></comp-icon><span>Dealer Filter</span>
              </div>
              <ng-container *ngIf="selectedDealer"><i class="material-icons filter-icon">person</i><span class="exist-filter ellipsis" *ngIf="selectedDealer" style="max-width: 200px;" (click)="isShowDealerSelect = true">{{selectedDealer.name}}</span><i class="material-icons filter-icon" style="margin-left: 8px;" (click)="clearDealerFilter()">cancel</i></ng-container>
            </div>
          </div>
          <div class="filter-box" *ngIf="isShowDealerSelect">
            <div class="select-list" #dealerSelect>
              <div class="search-result-input">
                <input class="list-search-input" autocomplete="off" type="text" placeholder="Search Dealer" [(ngModel)]="searchDealerTxt" (input)="searchFilterDealer(searchDealerTxt)"/>
              </div>
              <div style="max-height: 200px;overflow-y: auto; border-bottom: 1px solid rgba(0, 0, 0, 0.1);">
                <div class="select-result has-child selectitem" *ngFor="let dealer of searchDealerList" (click)="$event.stopPropagation();selectDealer(dealer)">
                  <div class="ellipsis" [class.selected]="dealer?.value == selectedDealer?.value">{{dealer.name}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="btn-area" *ngIf="!isOtherDealer">
          <div class="button button-white dense-icon-btn">
            <div class="btn-inner dense-icon-btn filter-btn">
              <div *ngIf="selectedStatusListLabels == 'All'" (click)="isShowStatusSelect = true">
                <comp-icon class="filter-icon" [icon]="'filter_list'" [size]="16" [color]="'hsla(0,0%,0%,0.6)'"></comp-icon><span>Status</span>
              </div>
              <ng-container *ngIf="selectedStatusListLabels != 'All'"><i class="material-icons filter-icon">expand_circle_down</i><span class="exist-filter ellipsis" *ngIf="selectedStatusList?.length" style="max-width: 200px;" (click)="isShowStatusSelect = true">{{selectedStatusListLabels}}</span><i class="material-icons filter-icon" style="margin-left: 8px" (click)="clearStatusFilter()">cancel</i></ng-container>
            </div>
          </div>
          <div class="filter-box" *ngIf="isShowStatusSelect" style="width: 180px">
            <div class="select-list" #statusSelect>
              <div style="border-bottom: 1px solid rgba(0, 0, 0, 0.1);">
                <div class="select-result selectitem">
                  <div style="color:hsla(0,0%,0%,0.87)">Status</div>
                </div>
                <div class="select-result has-child selectitem" *ngFor="let status of statusList" (click)="selectStatus($event, status)">
                  <div class="check-area"><i class="material-icons check-icon" *ngIf="!status.isSelected">check_box_outline_blank</i><i class="material-icons check-icon checked" *ngIf="status.isSelected">check_box</i></div>
                  <div>{{status.label}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="btn-area">
          <div class="button button-white dense-icon-btn">
            <div class="btn-inner dense-icon-btn filter-btn">
              <div *ngIf="selectedPlanListLabels == 'All'" (click)="isShowPlanSelect = true">
                <comp-icon class="filter-icon" [icon]="'filter_list'" [size]="16" [color]="'hsla(0,0%,0%,0.6)'"></comp-icon><span>Current Plan</span>
              </div>
              <ng-container *ngIf="selectedPlanListLabels != 'All'"><i class="material-icons filter-icon">expand_circle_down</i><span class="exist-filter ellipsis" *ngIf="selectedPlanList?.length" style="max-width: 200px;" (click)="isShowPlanSelect = true">{{selectedPlanListLabels}}</span><i class="material-icons filter-icon" style="margin-left: 8px" (click)="clearPlanFilter()">cancel</i></ng-container>
            </div>
          </div>
          <div class="filter-box" *ngIf="isShowPlanSelect" style="width: 180px">
            <div class="select-list" #planSelect>
              <div style="border-bottom: 1px solid rgba(0, 0, 0, 0.1);">
                <div class="select-result selectitem">
                  <div style="color:hsla(0,0%,0%,0.87)">Current Site Plan</div>
                </div>
                <div class="select-result has-child selectitem" *ngFor="let plan of planList" (click)="selectPlan($event, plan)">
                  <div class="check-area"><i class="material-icons check-icon" *ngIf="!plan.isSelected">check_box_outline_blank</i><i class="material-icons check-icon checked" *ngIf="plan.isSelected">check_box</i></div>
                  <div>{{plan.label}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- selected list -->
    <div class="filter" style="display: flex; justify-content: flex-end; padding-top: 10px;">
      <div *ngIf="selectedSiteList?.length" style="display: flex; align-items: center; gap: 8px;">
        <div>{{ selectedSiteList?.length }} Selected</div>
        <div class="select-comp" #selectDropdown [class.disabled]="isLoading" style="width: 180px">
          <div class="selectbox label" (click)="toggleSelectDropdown($event)">
            <div class="label" style="color: black; width: 160px"><span>{{ selectedSitePlan?.label }}</span></div>
            <svg xmlns="http://www.w3.org/2000/svg" height="16px" width="14px" viewBox="0 0 18 20">
              <path d="M0 0h24v24H0V0z" fill="none"></path>
              <path d="M12 4L16.58 8.59L15.17 10L12 6.83L8.83 10L7.41 8.59L12 4Z"></path>
              <path d="M12 17.17L15.17 14 L16.59 15.41L12 20L7.42 15.41L8.83 14L12 17.17Z"></path>
            </svg>
          </div>
          <div class="select-list" *ngIf="isUnfoldPlanDropdown" style="width: 180px">
            <div class="select-result has-child" *ngFor="let plan of sitePlanList" (click)="selectSitePlan($event, plan)">
              <div class="f-1 flex between">
                <div class="flex">
                  <div class="mr-7" *ngIf="selectedSitePlan?.value === plan?.value">
                    <comp-icon [icon]="'done'" [color]="'#2383e2'" [size]="18"></comp-icon>
                  </div>
                  <div class="mr-7" *ngIf="selectedSitePlan?.value != plan?.value">
                    <comp-icon [color]="'#2383e2'" [size]="18"></comp-icon>
                  </div>
                  <div>{{ plan?.label }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="btn-area">
          <div class="button button-primary" (click)="onClickBulkUpdatePlan()" [class.disabled]="isLoading">
            <div class="btn-inner">{{ isSubDealer ? 'Request Plan Changes' : 'Bulk Update'}}</div>
          </div>
        </div>
      </div>
      <div class="badge-list" *ngIf="!selectedSiteList?.length">
        <div class="basic-badge">Basic: {{basicPlanCount}}</div>
        <div class="video-vault-plan-badge">Video Vault: {{videoVaultPlanCount}}</div>
        <div class="video-vault-plus-plan-badge">Video Vault Plus: {{videoVaultPlusPlanCount}}</div>
        <div class="video-vault-plus-ai-plan-badge">Video Vault Plus AI: {{videoVaultPlusAICount}}</div>
      </div>
    </div>
  </div>
  <div class="table-area" *ngIf="!isLoading">
    <div class="content-body table-container">
      <table class="table-header" sortable-table="sortable-table" (sorted)="sortTableByColumn($event)">
        <colgroup>
          <col *ngFor="let col of tableHeader" [width]="col.width"/>
        </colgroup>
        <thead>
          <tr>
            <th *ngFor="let header of tableHeader" [sortable-column]="header.value"> 
              <div class="v-center">
                <div>{{header.name}}</div>
                <input *ngIf="header.isCheckbox" type="checkbox" [checked]="isAllSelected" (click)="toggleAllCheckbox($event)"/>
                <div class="--g-tooltip-content" *ngIf="header.tooltip" (mouseenter)="commonService.setTooltipPosition($event, 'top-center')">
                  <comp-icon class="--g-tooltip-icon" [icon]="'info'" [size]="16" [color]="'#55647B'"></comp-icon>
                  <div class="--g-tooltip" style="text-transform: none">
                    <div class="v-center" style="margin-bottom: 8px;">
                      <div class="Active" style="margin-right: 4px;"><i class="material-icons">check_circle</i>
                        <div>Active</div>
                      </div>
                      <div>Site is using Vault</div>
                    </div>
                    <div class="v-center" style="margin-bottom: 8px;">
                      <div class="Requested" style="margin-right: 4px;"> <i class="material-icons">alarm</i>
                        <div>Requested</div>
                      </div>
                      <div> Dealer has requested an upgrade.</div>
                    </div>
                    <div class="v-center" style="margin-bottom: 8px;">
                      <div class="Inactive" style="margin-right: 4px;"> <i class="material-icons">do_not_disturb_on</i>
                        <div>Inactive</div>
                      </div>
                      <div>Site is not using a vault</div>
                    </div>
                    <div class="v-center" style="margin-bottom: 8px;">
                      <div class="Unavailable" style="margin-right: 4px;"> <i class="material-icons">cancel </i>
                        <div>Unavailable</div>
                      </div>
                      <div>Dealer is on Basic plan</div>
                    </div>
                  </div>
                </div>
              </div>
            </th>
          </tr>
        </thead>
      </table>
      <div class="alternative-contents" *ngIf="determineElementToShow() === 'no-data'"> <i class="material-icons">inventory_2</i>
        <div>No Site List</div>
      </div>
      <div class="alternative-contents" *ngIf="determineElementToShow() === 'no-permission'"> <i class="material-icons">do_not_disturb_on</i>
        <div>Permission Denied</div>
      </div>
      <div class="table-body" *ngIf="determineElementToShow() === 'normal'">
        <table>
          <colgroup>
            <col *ngFor="let col of tableHeader" [width]="col.width"/>
          </colgroup>
          <tbody>
            <ng-container *ngIf="!isLoading">
              <tr *ngFor="let site of pagedItems" (mouseover)="showApproveSelector(site)" (mouseleave)="hideApproveSelector(site)">
                <td style="overflow: hidden;"> 
                  <input type="checkbox" [checked]="site.isSelected" (click)="toggleCheckbox(site, $event)"/>
                </td>
                <td [class.no-contents]="site.name === 'No Name'">{{ site.name }}</td>
                <td [class.no-contents]="site.name === 'No Name'">{{ site.dealer_name }}</td>
                <td *ngIf="!isOtherDealer"> 
                  <div class="v-center" style="gap: 8px;" [id]="'site-approval-'+ site.site_id">
                    <div [ngClass]="site.status"> <i class="material-icons" *ngIf="site.statusValue === 1">check_circle</i><i class="material-icons" *ngIf="site.statusValue === 2">alarm</i><i class="material-icons" *ngIf="site.statusValue === 3">do_not_disturb_on</i><i class="material-icons" *ngIf="site.statusValue === 4">cancel</i>
                      <div>{{ site.status }}</div>
                    </div>
                    <div class="approve-selector" *ngIf="site.statusValue === 2" [id]="'approval-'+site.site_id" (click)="$event.stopPropagation();onClickApprovePlan(site)"><i class="material-icons" style="font-size: 16px; color: hsla(0, 0%, 0%, 0.87)">task_alt</i>
                      <div class="tooltip-background" [id]="'tooltip-'+site.site_id">Approve Plan</div>
                    </div>
                  </div>
                </td>
                <td *ngIf="!isOtherDealer"> 
                  <div *ngIf="site.statusValue === 2" [ngClass]="computedPlanBadgeStyle(site?.requested_to_change_site_plan_id)">
                     {{ site.update_request_site_plan }}</div>
                  <div class="no-contents" *ngIf="site.statusValue != 2">No Data</div>
                </td>
                <td> 
                  <div [ngClass]="computedPlanBadgeStyle(site?.site_plan_id)">{{ site.site_plan }}</div>
                </td>
                <td>
                  <div *ngIf="site.is_trial_period" style="margin-left: 8px;font-size: 12px;color: #55647B;">
                     Trial Period (Until: {{site.trial_period_end_date | date: 'MM/dd/yyyy'}})</div>
                  <div *ngIf="site.next_site_plan_id != site.site_plan_id" style="margin-left: 8px;font-size: 12px;color: #55647B;">
                     Downgraded to {{site.next_site_plan}} starting on {{ computedNextMonth() }}</div>
                </td>
                <td>
                  <div class="more-content v-center" #siteActionMenus [id]="'site-'+ site.site_id" (mouseover)="setMorePosition(site.site_id)">
                    <div class="more-selector" (click)="$event.stopPropagation();toggleMenu(site)">
                      <comp-icon [icon]="'more_horiz'" [size]="20" [color]="'hsla(0, 0%, 0%, 0.87)'"></comp-icon>
                    </div>
                    <div class="more" [class.show]="site.isShowMenu" [id]="'more-site-'+site.site_id">
                      <div class="more-item row text-primary" *ngIf="site.statusValue === 2 && !isSubDealer" (click)="onClickApprovePlan(site)">
                        <div>Approve Plan</div>
                      </div>
                      <div class="more-item row" *ngIf="site.statusValue === 2 && isSubDealer" (click)="cancelRequestPlanChange(site)">
                        <div>Cancel Request</div>
                      </div>
                      <div class="more-item row" (click)="goToDetail($event, site)">
                        <div>Go to Detail</div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
      <!-- pagination-->
      <div class="pagination-area" *ngIf="isHasViewPermission">
        <div style="font-size:12px;padding-right: 7px;"></div>
        <div class="space"></div>
        <div class="flex" style="font-size:12px;padding-right: 7px; gap: 2px">
          <div>{{pageOffsetStart}} - {{pageOffsetEnd}}</div>
          <div>of </div>
          <div>{{totalItem}}</div>
        </div>
        <div class="pagination">
          <div class="page-mover">
            <div class="btn-area">
              <div class="button button-white" [class.disabled]="pager.currentPage === 1 || pager.currentPage === 0" (click)="setPage(pager.currentPage - 1)">
                <div class="btn-inner"><i class="material-icons" style="font-size: 16px" [class.disabled]="pager.currentPage === 1 || pager.currentPage === 0">arrow_back</i><span>Prev</span></div>
              </div>
            </div>
            <div class="btn-area">
              <div class="button button-white" [class.disabled]="pager.currentPage === pager.totalPages" (click)="setPage(pager.currentPage + 1)">
                <div class="btn-inner"><span>Next</span>
                  <comp-icon [icon]="'arrow_forward_n'" [color]="'#000'" [size]="16" [class.disabled]="pager.currentPage === pager.totalPages"></comp-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>